import axios from "axios";
import endpoints from "../../data/endpoints";

export const preflightRequest = () => axios.get(endpoints.server.preflight, {
    headers: {
        Authorization: ''
    }
});